export interface ChangeWorkOrderStageDesiredStartTime {
	startTime: number;
	workOrderStageId: number;
}

export class ChangeWorkOrderStageDesiredStartTime implements ChangeWorkOrderStageDesiredStartTime {
	constructor(data?: Partial<ChangeWorkOrderStageDesiredStartTime>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}